/** Shared, non-user-specific reCAPTCHA Enterprise actions. */
export type RecaptchaAction =
    | "vehicle_availability" | "test_drive" | "walkaround_video"
    | "share_email" | "share_sms" | "trade_in"
    | "sell_appraisal" | "referral_appraisal"
    | "sell_appointment" | "referral_appointment" | "financing_intent";

export const RECAPTCHA_ERROR = "We couldn't verify your request. Please try again.";

/** Incident hotfix: disabled until live Enterprise verification is validated.
 * This public flag must be set at build time so browser and server agree. */
export function isRecaptchaEnabled(): boolean {
    return process.env["NEXT_PUBLIC_RECAPTCHA_ENABLED"] === "true";
}
